import React, { useState } from "react";
import icons from "../../../../assets/images/icons";
import IdVerificationModal from "../../../../common/components/IdVerificationModal/IdVerificationModal";
import { useEscapeClose } from "../../../../common/hooks/useEscapeClose";
import { createChatRoom } from "../../apis/chatApi";
import { set as setCachedUser } from "../../stores/userDisplayUtils";
import styles from "./ContactModal.module.scss";

function ContactModal({ name, phone, photoUrl, auid, onClose, onCallClick, onOpenChat, suid }) {
  const [errorMessage, setErrorMessage] = useState(null);
  const [showIdVerification, setShowIdVerification] = useState(false);

  const isSelf =
    Boolean(auid) &&
    Boolean(window.loggedInUser?.uuid) &&
    String(auid) === String(window.loggedInUser.uuid);

  const handleClose = () => {
    setErrorMessage(null);
    onClose?.();
  };

  useEscapeClose(showIdVerification ? () => setShowIdVerification(false) : handleClose, true);

  const handleOverlayClick = (e) => {
    e.stopPropagation();
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handlePhoneButtonClick = () => {
    if (typeof onCallClick === "function") {
      onCallClick(name, phone, photoUrl);
    }
    onClose?.();
  };

  const handleChatButtonClick = async () => {
    if (!window.loggedInUser?.uuid) {
      onClose?.();
      window.memberEntry.openLogin();
      return;
    }
    if (!window.loggedInUser.auth) {
      setShowIdVerification(true);
      return;
    }
    setErrorMessage(null);
    try {
      const res = await createChatRoom({ other_user_id: auid });
      if (auid) {
        setCachedUser(auid, {
          name: (name && String(name).trim()) || auid,
          photo: photoUrl || null,
        });
      }
      onOpenChat(res);
      onClose?.();
    } catch (error) {
      console.error("채팅방 생성 실패:", error);
      setErrorMessage(error.message || "채팅방 생성에 실패했습니다.");
    }
  };

  return (
    <>
      {showIdVerification && <IdVerificationModal onClose={() => setShowIdVerification(false)} />}
      {!showIdVerification && (
        <div className={styles.contactModalOverlay} onClick={handleOverlayClick}>
          <div className={styles.contactModalContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.contactModalHeader}>
              {photoUrl ? (
                <img src={`${photoUrl}`} alt={name || ""} width={48} height={48} />
              ) : (
                <img src={icons.messager?.person} alt="" width={48} height={48} />
              )}
              <button
                type="button"
                className={styles.closeBtn}
                onClick={handleClose}
                aria-label="닫기"
              >
                <img src={icons.messager?.close} alt="" />
              </button>
            </div>
            {isSelf ? (
              <>
                <p className={styles.contactModalText}>
                  본인에게는 문의할 수 없어요
                  <br />
                  다른 상대를 선택해 주세요.
                </p>
                <div className={styles.contactModalButtonWrapper}>
                  <button
                    type="button"
                    className={`${styles.button} ${styles.chatButton}`}
                    onClick={handleClose}
                  >
                    확인
                  </button>
                </div>
              </>
            ) : (
              <>
                <p className={styles.contactModalText}>
                  이 중개사님에게 어떤 방식으로 <br />
                  문의하시겠어요?
                </p>
                <div className={styles.contactModalButtonWrapper}>
                  <button
                    type="button"
                    className={`${styles.button} ${styles.chatButton}`}
                    onClick={handleChatButtonClick}
                  >
                    <img src={icons.messager?.chat} alt="채팅으로 문의하기" />
                    <span>채팅으로 문의하기</span>
                  </button>
                  <button
                    type="button"
                    className={`${styles.button} ${styles.phoneButton}`}
                    onClick={handlePhoneButtonClick}
                  >
                    <img src={icons.messager?.phone} alt="전화로 문의하기" />
                    <span>전화로 문의하기</span>
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default ContactModal;
